<template>
  <b-card-footer>
    <b-input-group v-if="!dataItem.closed">
      <b-form-input
        v-model="messageItem.message"
        placeholder="Bir mesaj yazın..."
        :disabled="dataItem.id !== dataItem.id_users"
        @keydown.enter="sendMessage"
      />
      <b-input-group-append>
        <b-button
          variant="success"
          :disabled="dataItem.id !== dataItem.id_users"
          @click="sendMessage"
        >
          <FeatherIcon icon="SendIcon" />
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <b-alert
      v-else
      variant="warning"
      show
    >
      <div class="alert-body text-center">
        <span v-if="dataItem.user_closed">
          Mesajlaşma {{ dataItem.user_closed }} tarafından sonlandırıldı.
        </span>
        <span v-if="dataItem.customer_closed">
          Mesajlaşma {{ dataItem.customer_closed }} tarafından sonlandırıldı.
        </span>
      </div>
    </b-alert>
  </b-card-footer>
</template>

<script>
import {
  BCardFooter,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BAlert,
} from 'bootstrap-vue'

export default {
  name: 'CardFooter',
  components: {
    BCardFooter,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BAlert,
  },
  props: {
    sendMessage: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['chatMessages/dataItem']
    },
    messageItem() {
      return this.$store.getters['chatMessages/messageItem']
    },
  },
}
</script>
